var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "header__artwork--wrapper",
        style: {
          backgroundColor:
            "rgb(" +
            _vm.$root.content.allImages[
              _vm.$root.content.backgroundTile
            ].colors.DarkVibrant._rgb.join() +
            ")",
          backgroundImage:
            "url(" +
            _vm.$root.content.allImages[_vm.$root.content.backgroundTile]
              .Img200 +
            ")",
          boxShadow:
            "0 4px 36px -8px rgba(" +
            _vm.$root.content.allImages[
              _vm.$root.content.backgroundTile
            ].colors.DarkVibrant._rgb.join() +
            ", 1)"
        }
      },
      [
        _c(
          "div",
          { staticClass: "logo__wrapper" },
          [_vm.hasScrolledIn ? _c("game-of-thrones-logo") : _vm._e()],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header__wrapper" },
          [
            _c(
              "h2",
              {
                directives: [{ name: "balancetext", rawName: "v-balancetext" }],
                staticClass: "title"
              },
              [_vm._v(_vm._s(_vm.$root.content.header.title))]
            ),
            _vm._v(" "),
            _vm._l(_vm.$root.content.header.intro, function(par, i) {
              return _c(
                "p",
                {
                  directives: [
                    { name: "balancetext", rawName: "v-balancetext" }
                  ],
                  key: "main-intro-" + i,
                  staticClass: "intro"
                },
                [_vm._v("\n        " + _vm._s(par) + "\n      ")]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("hr", { staticClass: "whiteRule" }),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "options__wrapper" },
          _vm._l(_vm.$root.content.themes, function(theme) {
            return _c("theme-row", {
              key: "theme-row-" + theme,
              attrs: { theme: theme },
              on: { vote: _vm.handleVote, unvote: _vm.handleUnVote }
            })
          })
        )
      ]
    ),
    _vm._v(" "),
    _vm.message
      ? _c("div", { staticClass: "noResults__wrapper" }, [
          _c("p", { staticClass: "noResults__message" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "showcard__wrapper" },
      _vm._l(_vm.matches, function(match, i) {
        return _c("show-card", {
          key: "match-" + match.TITLE + "-" + i,
          attrs: { show: match, votes: Object.keys(_vm.votes) }
        })
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58e97edb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e97edb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/NED-0534-got-show-matcher.vue
// module id = null
// module chunks = 